module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_PLAFOND_KNAUF_ORGANIC_GRIS_PIERRE.8b9d1f71.webp";